import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import AboutSection from './components/AboutSection';
import CTABanner from './components/CTABanner';
import ServicesPreview from './components/ServicesPreview';
import WhyChooseUs from './components/WhyChooseUs';
import HowItWorks from './components/HowItWorks';
import ReviewsSection from './components/ReviewsSection';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <AboutSection />
        <CTABanner />
        <ServicesPreview />
        <WhyChooseUs />
        <HowItWorks />
        <ReviewsSection />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}